import React, { Component } from "react";
import Panel from "@/components/Panel";
import { createPortal } from 'react-dom';
import { PART_REPEATER_LIBRARY } from "../../../../constants/libraryConstants";
import { getPartLibraryListBySearch } from "../../../../services/Sierra/library";
import RepeaterModelSelection from "../../Content/modelSelection/repeaterModelSelection";
import '../../../../publicCss/netlist.css';
import "./index.css";

class RepeaterModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      pinList: [],
      modelFileType: 'SPICE'
    }
    this.dialogRoot = document.getElementById('root');
  }

  saveModel = () => {
    let { files, pinList, modelFileType } = this.state;
    if (this.childRef && this.childRef.getModel) {
      const info = this.childRef.getModel();
      files = info.files || files;
      pinList = info.pinList || pinList;
      modelFileType = info.type;
    }
    const pairs = pinList.map(item => { return [item.input, item.output] }).flat(2).filter(item => !!item.pin);
    const { partNumber, position } = this.props;
    this.props.saveModelInfo({
      partNumber,
      model:
      {
        files,
        pairs,
        type: modelFileType
      },
      position
    })
    this.props.save();
  }

  componentDidMount = () => {
    this.setDefaultData()
  }

  componentDidUpdate = (prevProps) => {
    if ((prevProps.partNumber !== this.props.partNumber) || prevProps.position !== this.props.position) {
      this.setDefaultData()
    }
  }

  setDefaultData = async () => {
    const { record: { model, connections, partNumber, position } } = this.props;
    let _model = model && typeof (model) === "object" ? model : { pairs: [], files: [], type: model.type || "SPICE" }
    if (!connections || !connections.length) {
      this.setState({
        files: _model.files || [],
        pinList: [],
        isUpdate: true,
        modelFileType: model.type || "SPICE"
      })
      return;
    }

    //init model files libraryId
    let files = [...(_model.files || [])];
    for (let item of files) {

      if (item.libraryId) {
        continue;
      }
      const partList = await getPartLibraryListBySearch({ partNumbers: [partNumber], type: PART_REPEATER_LIBRARY });
      const findPart = partList.length > 1 ? partList.find(it => it.position === position) : partList[0];
      const findModel = findPart && findPart.model ? (findPart.model.files || []).find(it => it.fileName === item.fileName) : null;
      if (!findModel) {
        continue;
      }

      item.libraryId = findModel.libraryId;
      _model.type = findPart.model.type || "SPICE";
    }

    let pinList = [];
    for (let pinItem of connections) {
      if ((!pinItem.input || !pinItem.input.length) && (!pinItem.output || !pinItem.output.length)) {
        continue;
      }
      const findInput = (_model.pairs || []).find(item => item.pin === pinItem.input[0]) || {};
      const findOutput = (_model.pairs || []).find(item => item.pin === pinItem.output[0]) || {};

      pinList.push({
        input: {
          pin: pinItem.input[0] || "",
          node: findInput.node || "",
          fileName: findInput.fileName || "",
          modelKey: findInput.modelKey || "",
          subckt: findInput.subckt || "",
          libraryId: findInput.libraryId || ""
        },
        output: {
          pin: pinItem.output[0] || "",
          node: findOutput.node || "",
          fileName: findOutput.fileName || "",
          modelKey: findOutput.modelKey || "",
          subckt: findOutput.subckt || "",
          libraryId: findOutput.libraryId || ""
        }
      })
    }
    this.setState({
      pinList,
      files: _model.files || [],
      isUpdate: true,
      modelFileType: _model.type || "SPICE"
    })
  }

  updateStatus = (isUpdate) => {
    this.setState({
      isUpdate
    })
  }

  onRef = (ref) => {
    this.childRef = ref;
  }

  renderDialog = () => {
    const { partNumber, position, maxWidth, maxHeight, libraryTreeInfo } = this.props;
    const { pinList, files, isUpdate, modelFileType } = this.state;

    const content = <Panel
      title={`Repeater Model - ${partNumber}${position ? ` - ${position}` : ""}`}
      className='sierra-repeater-connections-panel sierra-panel'
      position='panel-center-left'
      zIndex={2000}
      onCancel={() => { this.saveModel() }}
      width={700}
      draggable
      minHeight={200}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
    >
      <div className="sierra-repeater-connections-content">
        <RepeaterModelSelection
          onRef={this.onRef}
          files={files}
          pinList={pinList}
          modelFileType={modelFileType}
          isUpdate={isUpdate}
          maxWidth={maxWidth}
          maxHeight={maxHeight}
          libraryTreeInfo={libraryTreeInfo}
          updateStatus={this.updateStatus}
        />
      </div>
    </Panel>
    return createPortal(content, this.dialogRoot)
  }

  render = () => {
    const { text } = this.props;
    return <div>
      <span>{text || ""}</span>
      {this.renderDialog()}
    </div>
  }
}

export default RepeaterModel;